import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserInterface } from 'src/interfaces/user'

type State = {
  loading: boolean
  entity: UserInterface | null
}

const initialState: State = {
  loading: false,
  entity: null,
}

const { actions, reducer } = createSlice({
  name: 'get_user',
  initialState,
  reducers: {
    updateEntity: (state, action: PayloadAction<UserInterface>) => {
      state.entity = action.payload
    },
    updateLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
  },
})

export { reducer }
export default actions
